module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Tools/Pantone-05a1090c28a2f2b0d9794080fba0b2ef960ee2cb1c108edb89dc1b5dca0adc26.svg";